import axios from "axios";

const http = axios.create({ baseURL: `${process.env.REACT_APP_BACKEND_URL}/graphql`, withCredentials: true });
const fields = "id seriesId title description category startsAt endsAt timeZone venueName city latitude longitude destinationId organizer sourceUrl registrationUrl imageUrl status";

async function request(query, variables = {}) {
  const { data } = await http.post("", { query, variables });
  if (data.errors?.length) throw new Error(data.errors[0].message || "Event administration failed");
  if (!data.data) throw new Error("Empty administration response");
  return data.data;
}

export const eventsAdminApi = {
  async list() {
    return (await request(`query AdminRideEvents { adminRideEvents { ${fields} } }`)).adminRideEvents;
  },
  async create(input) {
    return (await request(`mutation CreateRideEvent($input: AdminRideEventInput!) { adminCreateRideEvent(input: $input) { ${fields} } }`, { input })).adminCreateRideEvent;
  },
  async update(id, input) {
    return (await request(`mutation UpdateRideEvent($id: ID!, $input: AdminRideEventInput!) { adminUpdateRideEvent(id: $id, input: $input) { ${fields} } }`, { id, input })).adminUpdateRideEvent;
  },
  async createSeries(input) {
    return (await request("mutation CreateRideEventSeries($input: AdminRideEventSeriesInput!) { adminCreateRideEventSeries(input: $input) { id title } }", { input })).adminCreateRideEventSeries;
  },
  async publish(id) {
    return (await request(`mutation PublishRideEvent($id: ID!) { adminPublishRideEvent(id: $id) { ${fields} } }`, { id })).adminPublishRideEvent;
  },
  async unpublish(id) {
    return (await request(`mutation UnpublishRideEvent($id: ID!) { adminUnpublishRideEvent(id: $id) { ${fields} } }`, { id })).adminUnpublishRideEvent;
  },
};
